import { render, staticRenderFns } from "./SendEgiftPanelApproval.vue?vue&type=template&id=627d1f40&scoped=true"
import script from "./SendEgiftPanelApproval.vue?vue&type=script&lang=ts"
export * from "./SendEgiftPanelApproval.vue?vue&type=script&lang=ts"
import style0 from "./SendEgiftPanelApproval.vue?vue&type=style&index=0&id=627d1f40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627d1f40",
  null
  
)

export default component.exports